// IMPORTANT: This must be imported FIRST to set __webpack_public_path__ before any chunks load
import '../publicpath';

import React from 'react';
import ReactDOM from 'react-dom';

import { App } from './App';

ReactDOM.render(<App />, document.getElementById('root'));
